import {Group} from '@app/core/models/group.model';
import {User} from '@app/core/models/user.model';
import {Message} from '@app/core/models/message.model';
import {RDate} from '@app/core/models/rDate.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';

export class Conversation extends BaseModel {
	public id: number;
	public conversation_name: string;
	public unread_notifications: number;
	public users: User[];
	public group: Group;
	public messages: Message[];
	public latest_message: Message;
	public is_group_conversation: boolean;
	public is_personal_conversation: boolean;
	public unread_notifications_count: number;
	public created_at: RDate;
	public updated_at: RDate;

	constructor(tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public getInitials(): string {
		return this.conversation_name.slice(0, 1).toUpperCase();
	}

	public deserialize(input: any): this {
		Object.assign(this, input);
		this.users = [];
		this.messages = [];
		if (input.users && input.users[0] && !(input.users[0] instanceof User)) {
			this.users = input.users.map(userInput => new User(this.tenantTZ, this.interService).deserialize(userInput));
		}
		if (input.messages && input.messages[0] && !(input.messages[0] instanceof Message)) {
			this.messages = input.messages.map(messageInput => new Message(this.tenantTZ, this.interService).deserialize(messageInput));
		}
		if (input.group && input.group[0] && !(input.group[0] instanceof Group)) {
			this.group = new Group(this.tenantTZ, this.interService).deserialize(input.group);
		}
		// if (input.latest_message) {
		// 	this.latest_message = (input.latest_message.length === 0)
		// 		? undefined
		// 		: new Message(this.tenantTZ, this.interService).deserialize(input.latest_message[0]);
		// }
		if (input.created_at && !(input.created_at instanceof RDate)) {
			this.created_at = new RDate(this.tenantTZ, this.interService).deserialize(input.created_at);
		}
		if (input.updated_at && !(input.updated_at instanceof RDate)) {
			this.updated_at = new RDate(this.tenantTZ, this.interService).deserialize(input.updated_at);
		}

		return this;
	}
}
